import { useQuery } from '@tanstack/react-query';
import { parseTimeToSeconds } from 'src/meetings/detail/tabs/transcript/timeUtils';
import type { Transcript } from 'src/meetings/detail/tabs/transcript/types';

type UseTranscriptResult = {
  transcript: Transcript | undefined;
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  refetch: () => void;
};

type Props = {
  eventId: string;
  enabled?: boolean;
};

export const useTranscript = ({ eventId, enabled = true }: Props): UseTranscriptResult => {
  const { data, isLoading, isError, error, refetch } = useQuery<Transcript>({
    queryKey: ['calendar-events', eventId, 'transcript'],
    enabled,
    select: data => {
      if (!data?.segments) {
        return data;
      }

      return {
        ...data,
        segments: [...data.segments].sort(
          (a, b) => parseTimeToSeconds(a.startTime) - parseTimeToSeconds(b.startTime),
        ),
      };
    },
  });

  return {
    transcript: data,
    isLoading,
    isError,
    error,
    refetch,
  };
};
